import { IRouter } from '@cp/shared/router';
import { Intent, IntentData } from './intent';
export type IntentStorage = { getItem(): IntentData | null; setItem(v: IntentData): void; clear(): void; has(): boolean };

export class IntentionService {
  #storage: IntentStorage;
  #router: IRouter;

  constructor(storage: IntentStorage, router: IRouter) {
    this.#storage = storage;
    this.#router = router;
  }

  remember(intent: Intent) {
    this.#storage.setItem(intent.toJSON());
  }

  has() {
    return Boolean(this.#storage.getItem());
  }

  pickIntent() {
    let intent: Intent | null = null;
    const url = new URL(this.#router.location.href);
    if (url.searchParams.has('intent')) {
      intent = Intent.parse(url.searchParams.get('intent') as string);
      url.searchParams.delete('intent');
      // this.#router.navigate(url, { shallow: true, method: 'replace' });
      this.#router.navigate(url, { shallow: true });
    } else if (this.#storage.has()) {
      const data = this.#storage.getItem();
      intent = new Intent(data as IntentData);
      this.#storage.clear();
    }
    return intent;
  }

  injectIntention(url: URL, customIntent?: Intent): URL {
    const intent = customIntent || this.pickIntent();
    if (intent) {
      url.searchParams.set('intent', intent.toString());
    }
    return url;
  }

  clear() {
    this.#storage.clear();
  }
}
